import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'トップ', path: '/' },
    { name: 'まごころヘルパーについて', path: '/about' },
    { name: 'サービス内容', path: '/service' },
    { name: '採用情報', path: '/recruit' },
    { name: '法人・アクセス情報', path: '/company' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center">
              <img 
                src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/1ca92b05a3a8fac4d9f8062f2b2f945d.png" 
                alt="まごころヘルパー ロゴ" 
                className="w-12 h-12 object-contain"
              />
            </div>
            <h1 className="logo-watercolor whitespace-nowrap">
              まごころヘルパー
            </h1>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === item.path
                    ? 'text-cyan-600'
                    : isScrolled
                    ? 'text-gray-700 hover:text-cyan-600'
                    : 'text-gray-900 hover:text-cyan-600'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`text-2xl ${isScrolled ? 'text-gray-900' : 'text-gray-900'} ${
              isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
            }`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="container mx-auto px-6 py-6 space-y-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-3 font-medium transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-cyan-600'
                    : 'text-gray-700 hover:text-cyan-600'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
